import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SearchFormComponent } from './search-form/search-form.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MainTabsComponent } from './main-tabs/main-tabs.component';
import  { HeaderComponent } from './header/header.component';
import { CampaignHeaderComponent } from './campaign-header/campaign-header.component';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { FilterComponent } from './filter/filter.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModalComponent } from './common-modal/common-modal.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

@NgModule({
    imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    TourMatMenuModule,
    SearchFormComponent,
    MainTabsComponent,
    CampaignHeaderComponent,
    HeaderComponent,
    FilterComponent,
    MatDialogModule,
    CommonModalComponent,
    MatDatepickerModule,
    MatNativeDateModule
],
    exports: [
        SearchFormComponent,
        MainTabsComponent,
        CampaignHeaderComponent,
        HeaderComponent,
        FilterComponent
    ],
    providers: [MatIconRegistry]
})
export class BlocksModule { }
